import React, {useMemo} from 'react'

export interface ReadingTimeProps {
  readingTime: number;
}

const ReadingTime: React.FC<ReadingTimeProps> = ({readingTime}) => {
  const mappedEmojis = useMemo(() => {
    return Array.from({length: Math.ceil(readingTime / 5)}, (_, index) => index + 1).map(n => <span key={n}>📖</span>)
  }, [readingTime])

  return (
    <>
      {mappedEmojis} &nbsp; {readingTime}min read
    </>
  )
}

export default ReadingTime
